import { call, takeEvery } from 'redux-saga/effects';
import frameActions from '@/constants/frames';
import { postMessage } from '@/utils/sagaHelper';
import actions from '../constants';

export function* closeRequestMessage({ code }) {
  yield call(postMessage, { type: frameActions.FRAME_REQUEST_CANCELLED, code });
}

export function* markPollingCompleteMessage({ code }) {
  yield call(postMessage, { type: frameActions.FRAME_REQUEST_WORKFLOW_INITIALIZED_SUCCESS, code });
}

export function* newRequestSuccessMessage({ code, result }) {
  yield call(postMessage, { type: frameActions.FRAME_REQUEST_CREATED, code, name: result.name });
}

export default function* requestFrameMessages() {
  yield takeEvery(actions.CLOSE_REQUEST, closeRequestMessage);
  yield takeEvery(actions.MARK_POLLING_COMPLETE, markPollingCompleteMessage);
  yield takeEvery(actions.NEW_REQUEST_SUCCESS, newRequestSuccessMessage);
}
